module.exports = __webpack_public_path__ + "./images/eb9667f5a34800ef0beecea55335236d.webp";